import { ExcavationSite } from './types';

export const PERIOD_COLORS: Record<string, string> = {
  'Neolitik': '#10b981', // Emerald
  'Tunç Çağı': '#f59e0b', // Amber
  'Demir Çağı': '#ef4444', // Red
  'Roma': '#8b5cf6', // Violet
  'Helenistik': '#3b82f6', // Blue
  'Bizans': '#ec4899', // Pink
  'Hitit': '#d97706', // Dark Amber
  'Frig': '#a855f7', // Purple
  'Likya': '#06b6d4', // Cyan
  'Osmanlı': '#14b8a6', // Teal
  'Selçuklu': '#0ea5e9', // Sky
  'Bilinmiyor': '#78716c' // Stone
};

export const SAMPLE_DATA: ExcavationSite[] = [
  { 
    id: '1', 
    name: 'Göbeklitepe', 
    location: 'Şanlıurfa', 
    period: 'Neolitik', 
    description: 'Tarihin bilinen en eski tapınak kompleksi. "Tarihin Sıfır Noktası" olarak bilinir.',
    lat: 37.2232,
    lng: 38.9224
  },
  { 
    id: '2', 
    name: 'Ephesus (Efes)', 
    location: 'İzmir', 
    period: 'Roma', 
    description: 'Dünyanın en iyi korunmuş antik kentlerinden biri, Artemis Tapınağı\'na ev sahipliği yapar.',
    lat: 37.9422,
    lng: 27.3636
  },
  { 
    id: '3', 
    name: 'Çatalhöyük', 
    location: 'Konya', 
    period: 'Neolitik', 
    description: 'İnsanlık tarihinin ilk büyük yerleşim yerlerinden biri, UNESCO Dünya Mirası.',
    lat: 37.6675,
    lng: 32.8283
  },
  { 
    id: '4', 
    name: 'Troya', 
    location: 'Çanakkale', 
    period: 'Tunç Çağı', 
    description: 'Homeros\'un İlyada destanına konu olan efsanevi kent.',
    lat: 39.9576,
    lng: 26.2389
  },
  { 
    id: '5', 
    name: 'Hattuşaş', 
    location: 'Çorum', 
    period: 'Hitit', 
    description: 'Hitit İmparatorluğu\'nun başkenti, anıtsal kapıları ve surlarıyla ünlüdür.',
    lat: 40.0194,
    lng: 34.6154
  },
  { 
    id: '6', 
    name: 'Aphrodisias', 
    location: 'Aydın', 
    period: 'Roma', 
    description: 'Aşk ve güzellik tanrıçası Afrodit\'e adanmış antik kent.',
    lat: 37.7088,
    lng: 28.7240
  },
  { 
    id: '7', 
    name: 'Perge', 
    location: 'Antalya', 
    period: 'Roma', 
    description: 'Pamphylia bölgesinin en önemli kentlerinden biri, stadyumu ve tiyatrosuyla ünlüdür.',
    lat: 36.9608,
    lng: 30.8524
  },
  { 
    id: '8', 
    name: 'Zeugma', 
    location: 'Gaziantep', 
    period: 'Roma', 
    description: 'Fırat Nehri kıyısında, mozaikleriyle ünlü antik kent.',
    lat: 37.0583,
    lng: 37.8683
  },
  { 
    id: '9', 
    name: 'Gordion', 
    location: 'Ankara', 
    period: 'Frig', 
    description: 'Frigya Krallığı\'nın başkenti, Kral Midas\'ın şehri.',
    lat: 39.6508,
    lng: 31.9833
  },
  { 
    id: '10', 
    name: 'Sagalassos', 
    location: 'Burdur', 
    period: 'Roma', 
    description: 'Bulutların üzerindeki şehir, Antoninler Çeşmesi ile ünlüdür.',
    lat: 37.6775,
    lng: 30.5208
  },
  {
    id: '11',
    name: 'Nemrut Dağı',
    location: 'Adıyaman',
    period: 'Helenistik',
    description: 'Kommagene Krallığı\'na ait devasa heykeller ve tümülüs.',
    lat: 37.9806,
    lng: 38.7408
  },
  {
    id: '12',
    name: 'Myra',
    location: 'Antalya',
    period: 'Likya',
    description: 'Kaya mezarları ve Aziz Nikolaos Kilisesi ile bilinir.',
    lat: 36.2575,
    lng: 29.9856
  }
];

export const CSV_HEADER_MAPPING = {
  name: ['ad', 'isim', 'name', 'site', 'yer'],
  location: ['konum', 'şehir', 'il', 'location', 'city', 'region'],
  period: ['dönem', 'çağ', 'period', 'era'],
  description: ['açıklama', 'detay', 'description', 'info'],
  lat: ['enlem', 'lat', 'latitude'],
  lng: ['boylam', 'lng', 'long', 'longitude']
};